import ConfirmButton from "../../../common/components/ConfirmButton";

export const TableActionRemoveFromFile = ({
  removeLoanFromFile,
  item,
  fileId,
}) => {
  return (
    <ConfirmButton
      refreshKey={item.LoanId}
      label="Remove loan from File"
      action={() => removeLoanFromFile(fileId, item.LoanId)}
    />
  );
};

export default TableActionRemoveFromFile;
